import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=22d98b64&scoped=true&"
import script from "./redirect.vue?vue&type=script&lang=js&"
export * from "./redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d98b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d98b64')) {
      api.createRecord('22d98b64', component.options)
    } else {
      api.reload('22d98b64', component.options)
    }
    module.hot.accept("./redirect.vue?vue&type=template&id=22d98b64&scoped=true&", function () {
      api.rerender('22d98b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/user/profile/tabs/redirect.vue"
export default component.exports